<!--
 * @Descripttion: 
 * @version: 
 * @Author: youquan.yu
 * @Date: 2020-08-11 09:52:57
 * @LastEditors: youquan.yu
 * @LastEditTime: 2020-09-28 14:16:36
-->
<template>
    <div class="PersonalCenterDiv">
        <div class="LeftContentLabelDiv">
            <label
            :class="PHAnswerLabel?'ActiveLabel':'UnActiveLabel'"
            @click="PHQuestionLabel=false;PHAnswerLabel=true;">{{ i18n.$t('UserInfoAnswer') }}</label>
            <label
            v-if="Group != 'ROLE_aftersale2'"
            :class="PHQuestionLabel?'ActiveLabel':'UnActiveLabel'"
            @click="PHQuestionLabel=true;PHAnswerLabel=false;">{{ i18n.$t('UserInfoQuestion') }}</label>
        </div>
        <div class="LeftContentContentDiv">
            <v-PHAnswer v-if="PHAnswerLabel"></v-PHAnswer>
            <v-PHQuestion v-if="PHQuestionLabel"></v-PHQuestion>
        </div>
    </div>
</template>
<script>
import vPHAnswer from '@/components/PersonalCenter/PHAnswer'
import vPHQuestion from '@/components/PersonalCenter/PHQuestion'
import { useI18n } from "@/i18nPlugin";
import { defineComponent, ref } from "vue";
export default defineComponent({
    setup() {
        const i18n = useI18n();
        const PHQuestionLabel = ref(false);
        const PHAnswerLabel = ref(true);
        const Group = localStorage.getItem("Group");

        const  getQueryVariable = (variable) =>{
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i=0;i<vars.length;i++) {
                    var pair = vars[i].split("=");
                    if(pair[0] == variable){return pair[1];}
            }
            return(false);
        }

        const ShowWhichLabel = () => {
            if(getQueryVariable("type") == "Question") {
                PHQuestionLabel.value = true;
                PHAnswerLabel.value = false;
            }else {
                PHQuestionLabel.value = false;
                PHAnswerLabel.value = true;
            }
        }

        return {
            i18n,
            Group,
            PHQuestionLabel,
            PHAnswerLabel,
            ShowWhichLabel
        }
    },
    mounted() {
        this.ShowWhichLabel();
    },
    components: {
        vPHAnswer,
        vPHQuestion
    },
})
</script>
<style lang="less" scoped>
    .PersonalCenterDiv {
        margin-top: 20px;
        text-align: left;
        display: grid;
        background: #FFFFFF;
    }
    .LeftContentLabelDiv {
        // position: absolute;
        margin-left: 30px;   //文章显示
        margin-top: 30px;
        text-align: left;
        margin-bottom: 1px;
    }
    .ActiveLabel {
        margin-right: 45px;
        font-size: 20px;
        color: #03a0d6;
        cursor: pointer;
    }
    .UnActiveLabel {
        margin-right: 45px;
        font-size: 20px;
        color: #353535;
        cursor: pointer;
    }
    .LeftContentContentDiv {
        margin-top: 5px;
        min-height: 150px;
    }
</style>